import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Dropdown from 'components/Core/Dropdown';

const Popover = ({
  children,
  content,
  visible = true,
  onVisibleChange,
  ButtonProps,
  ...otherProps
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (e) => {
    setAnchorEl(e?.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(false);
  };

  useEffect(() => {
    if (anchorEl !== null) {
      onVisibleChange?.(anchorEl);
    }
  }, [anchorEl]);

  useEffect(() => {
    if (!visible && anchorEl) {
      setAnchorEl(false);
    }
  }, [visible]);

  if (!children) {
    return <></>;
  }

  return (
    <>
      <PopoverButton onClick={handleClick} data-testid="popover-button" {...ButtonProps}>
        {children}
      </PopoverButton>
      <Dropdown
        anchorEl={anchorEl}
        open={!!anchorEl && visible}
        onClose={handleClose}
        {...otherProps}
      >
        {content}
      </Dropdown>
    </>
  );
};

export default Popover;

const PopoverButton = styled.div`
  width: fit-content;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
